import {assert} from 'Asserts';
import {MinimalStorableSummaryWithSchemaId} from 'constants/SampleConstants';
import {BioentitySummary} from 'graphql-client/declarative-translations/external/RESTTypes';
import {SchemaFieldSelectorsDict} from 'notebook/structured-tables/hooks/useSelectorsById';
import {ProcessTableLocation} from 'processes/ProcessConstants';
import {CreateProcessButtonQuery} from 'processes/tables/create-process-button/__generated/CreateProcessButtonQuery';
import createEmptyTaskTableFromSchema from 'processes/tables/createEmptyTaskTableFromSchema';

import {ProcessTaskStructuredTable} from '../ProcessTaskStructuredTableAdapter';
import findMatchingDestinationColumnIndex from './findMatchingDestinationColumnIndex';
import getMatchingColumnConstraints from './getMatchingColumnConstraints';
import {propagateItemsToDestinationTable} from './propagateContentFromSourceToDestinationTable';

type ProcessTaskSchema = CreateProcessButtonQuery['processTaskSchemasSupportingPlatformFeature'][number];
export default function mapItemsToTaskTable(
  schema: ProcessTaskSchema,
  items: Array<BioentitySummary> | Array<MinimalStorableSummaryWithSchemaId>,
  selectorsById: SchemaFieldSelectorsDict
): {
  successfullyMappedColumn: boolean;
  taskTable: ProcessTaskStructuredTable;
  footerMessage?: string;
} {
  assert(items.length > 0, 'Must have at least 1 item');
  let taskTable = createEmptyTaskTableFromSchema({
    name: schema.name,
    taskSchema: schema,
    tableLocation: ProcessTableLocation.CREATE_MODAL,
    locked: false,
    selectorsById,
  });
  const columnConstraints = getMatchingColumnConstraints(items);
  const destinationColumnIndex = findMatchingDestinationColumnIndex(columnConstraints, schema, taskTable);
  let footerMessage;
  let successfullyMappedColumn = false;
  if (destinationColumnIndex != null) {
    taskTable = propagateItemsToDestinationTable({
      items,
      destinationColumnIndex,
      destinationTable: taskTable,
    });
    successfullyMappedColumn = true;
  } else {
    footerMessage = `No columns in "${schema.name}" were valid destinations for the selected items.`;
  }

  return {successfullyMappedColumn, taskTable, footerMessage};
}
